import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="tinymce"
export default class extends Controller {
  static values = {
    config: { type: String, default: 'default' },
    options: Object
  }

  connect() {
    // The random ID every time is necessary because it is the selector that TinyMCERails.initialize
    // will use to initialize TinyMCE in a specific field.
    // If the field come from a Turbo Stream, this will also help re-initialize the field.
    const fieldId = 'tinymce-field-' + crypto.randomUUID();
    this.element.id = fieldId;

    const options = {selector: `#${fieldId}`, ...this.optionsValue}
    console.log("[TinyMCE controller]", this.configValue, options)
    // tinyMCE is initialized to an element using the random ID as selector
    TinyMCERails.initialize(this.configValue, options);
  }

  disconnect () {
    tinymce.remove()
  }
}
